import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { ITipResponse } from '../models/tip';

@Injectable({
  providedIn: 'root'
})
export class TipsService {

    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getAllTipsByBuildingId(buildingId: string): Observable<ITipResponse> {
        const url = environment.apiBaseUrl + endpoints.getAllTips.replace(':buildingId', buildingId);
        return this.http.get<ITipResponse>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    getTipLogsByTipId(tipId: number): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.getTipsLog.replace(':tipId', String(tipId));
        return this.http.get<any>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateTipStatus(tipId: number, new_status: string, note: string): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateTipStatus.replace(':tipId', String(tipId));
        const data = { new_status, note };
        return this.http.put(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }
}